module.exports = __webpack_public_path__ + "static/media/Categories.d72bb322.png";